import { DARK_MODE_PROVIDER_LOGOS } from './darkModeProviderLogos';

export const generatePublicImagePath = ({
  type,
  name,
  src,
  fileExtension = 'png',
  baseUrl,
  dark,
}: {
  type?: string;
  name?: string;
  src?: string;
  fileExtension?: string;
  baseUrl?: string;
  dark?: boolean;
}) => {
  const currentOrigin = window.location.origin;
  let publicImagePath = '';
  let origin = '';
  if (currentOrigin.includes(`http://localhost`)) {
    origin += '/public/images';
  } else {
    origin += `${baseUrl || ''}/images`;
  }

  if (src) {
    publicImagePath = `${origin}/${src}`;
  } else {
    switch (type) {
      case 'resourceType':
        publicImagePath = `${origin}/${type}/${name
          ?.split('::')
          ?.join('-')
          .toLowerCase()}.${fileExtension}`;
        break;
      case 'framework':
        publicImagePath = `${origin}/${type}/${name?.toLowerCase()}.${fileExtension}`;
        break;
      case 'provider': {
        // Logos that are dark on transparent swap to their light variant in
        // dark mode (other providers read fine as-is).
        const providerName = name?.toLowerCase();
        const resolvedName =
          (dark && providerName && DARK_MODE_PROVIDER_LOGOS[providerName]) ||
          providerName;
        publicImagePath = `${origin}/${type}/${resolvedName}.${fileExtension}`;
        break;
      }
      default:
        publicImagePath = `${origin}/${type}/${name?.toLowerCase()}.${fileExtension}`;
    }
  }

  return publicImagePath;
};
